let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("c7JYF")).then(() => parcelRequire('5zX31'));